<div>
    <aum-search placeholder="search" floatLabel="always" (search)="applyFilter($event)"> </aum-search>
</div>
<div>
    <aumico-table
        [options]="options"
        [data]="data"
        [delegate]="this"
        [filterSubject]="filterSubject"
        [singleSelection]="true"
        [savedSingleSelectionId]="savedSelectionId"
        detachPager="true"
    >
    </aumico-table>
</div>
